import React, { useEffect, useState } from 'react';
import { SupplierModel } from '@utmost.co/enterprise-models';
import { AvatarProps } from '@utmost.co/utmost-design-system';
import { buildMediaPicUri } from 'src/utils/OrgUtils';
import SupplierUrl from 'src/static/images/supplier.svg';
import Avatar from './Avatar';
import { AvatarSize } from './Avatar.types';

interface Props extends AvatarProps {
  supplier?: DeepMaybe<SupplierModel>;
  unsavedAvatar?: string;
  cacheBust?: boolean;
  onClick?: (e: any) => void;
  size?: AvatarSize;
  dataTest?: string;
}

const SupplierAvatar: React.FC<React.PropsWithChildren<Props>> = ({ supplier, unsavedAvatar, dataTest, ...rest }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (supplier?.logo) {
      setSrc(buildMediaPicUri(supplier.logo));
    }
  }, [supplier]);
  return <Avatar defaultSrc={SupplierUrl} src={unsavedAvatar || src} {...(rest as any)} dataTest={dataTest} />;
};

SupplierAvatar.defaultProps = { size: 'm' };

export default SupplierAvatar;
